import React, {Component} from "react";
import PropTypes from "prop-types";
import {arrayMove} from "react-sortable-hoc";
import SortableCoursesList from './SortableCoursesList';

class SortableCourses extends Component {
    state = {
        items: [...this.props.items]
    };

    onSortEnd = ({oldIndex, newIndex}) => {
        this.setState({
            items: arrayMove(this.state.items, oldIndex, newIndex),
        });
    };

    //Lifecycle
    componentWillReceiveProps(nextProps) {
        if (this.props.items !== nextProps.items) {
            this.setState({items: nextProps.items});
        }
    };

    render() {
        return (
            <SortableCoursesList
                items={this.state.items}
                number={this.props.index}
                onSortEnd={this.onSortEnd}
                handleChangeVisible={this.props.handleChangeVisible}
                removeAssignedTest={this.props.removeAssignedTest}
            />
        );
    }
}

SortableCourses.propTypes = {
    items: PropTypes.array.isRequired,
    index: PropTypes.number,
    handleChangeVisible: PropTypes.func,
    removeAssignedTest: PropTypes.func
};

export default SortableCourses;


// WEBPACK FOOTER //
// ./src/components/AdminPanel/Strategy/SortableCourses.js